import React from "react"
import { graphql } from "gatsby"
import { Box } from "@mui/material"
import { PortableText } from '@portabletext/react'
import { ScrollHandler } from "helpers"
import { All } from "serializers"
import { Seo, Gdpr } from "components"


const Basic = ({ location, data }) => {
  // FUTURE SELF
  // This check covers the case where no sections have been added and your
  // are in the process of adding the first section. It checks that the content array
  // both exists and if it does that the first value is not null
  // if (!data.sanityPage?.content) return null
  if (!data.sanityPage?.content[0]) return null

  // FUTURE SELF
  // This filters the array passed to the Portable Text component
  // so that the site doesn't break in watch mode while you are trying
  // to add a component.
  const content = data?.sanityPage?.content?.filter(n => n)

  // const PageContext = React.createContext(data?.sanityPage?.pageTags ?? {})

  return (
    <>
      <Seo data={data.sanityPage?._rawSeoContent ?? null} />
      <Gdpr gdpr={data?.sanityConfig?.privacy?.gdpr ?? true}/>
      {/* <PageContext.Provider value={42}> */}
        <Box
          component={PortableText}
          // blocks={content}
          value={content}
          // serializers={All}
          components={All}
          display="flex"
          flexDirection="column"
          minHeight="100vh" // Required in order to allow the footer to pin to the bottom
        />
      {/* </PageContext.Provider> */}
      <ScrollHandler location={location} />
    </>
  )
}

export const queryBasicPage = graphql`
  query ($slug: String) {
    sanityPage(slug: { current: { eq: $slug } }) {
      ...PageInfo
    }
    sanityConfig {
      privacy {
        gdpr
      }
    }
  }
`
export default Basic
